<app-authorized-guard [authorized]="!unauthorized">
  <div *ngIf="sub$ | async as sub">
    <app-plans-chooser
      [active]="sub.plan.id"
      [pending]="pending"
      (select)="handlePlanSelect($event)"
    ></app-plans-chooser>
  </div>
</app-authorized-guard>
<div class="change-plan-footer">
  <a mat-raised-button routerLink="/billing">Back</a>
</div>
